import './style.less';
import { integrations } from '@prolaera/library';
import { keyBy, values } from 'lodash';

export default function($log, $state, ProfileClass, ApiClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  const { company_id } = ProfileClass.profileComplete.profile;

  /**
   * Deletes a company's integration and reruns the activation function
   *
   * @param {Object} - Accepts a partial of an integration object, only requiring that the integration_id property is present
   *
   * @throws - Any errors from the ApiClass
   */
  vm.delete = ({ integration_id }) => {
    ApiClass.companiesIdTypeTypeIdDelete({
      manage: true,
      id: company_id,
      type: 'integrations',
      type_id: integration_id
    })
      .then(() => activate())
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  /**
   * Sets the state on the page by starting with the JSON list of integrations and taking an array of
   * configured integrations. Any data from the configured integrations is added to the list, along
   * with a prop to show that it's been configured, and then that list is used to set the state
   *
   * @param {Object} configuredIntegrations - an array of partial integration objects from the server
   */
  function buildIntegrationsList(configuredIntegrations, external_integrations = {}) {
    const integrationsList = configuredIntegrations.reduce((intAcc, configuredIntegration) => {
      const { active, integration_id } = configuredIntegration;
      if (integration_id in intAcc) {
        intAcc[integration_id] = { ...intAcc[integration_id], ...configuredIntegration, active, configured: true };
      }

      return intAcc;
    }, keyBy(integrations, 'id'));

    vm.integrations = values(integrationsList);
  }

  /**
   * Bootstraps the page by making a request for the company's configured integrations, and passes that
   * to a function that initiates the state.
   *
   * @throws - errors from the ApiClass
   */
  function activate() {
    $log.debug('Integrations Controller Activated');
    ApiClass.companiesIdGet({ manage: true, id: company_id }, null, { queryParams: { integrations: true } })
      .then(({ data: { integrations, company: { external_integrations } } }) =>
        buildIntegrationsList(integrations, external_integrations)
      )
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/settings/integrations/get/index.js